import styled from "styled-components";

export const PremiumPubTournamentsWrapper = styled.div`
  background: #240f60;
  width: 100%;
  padding: 20px 0 23px;

  .swiper {
    width: calc(100% - 16px); // 전체 너비에서 왼쪽 패딩 16px를 뺌
    margin-left: 16px; // left 대신 margin-left 사용
    padding-right: 16px; // 오른쪽 여백 16px 추가
    overflow: visible;
  }
`;

export const PremiumPubTournamentsHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  color: #ffffff;
  padding: 0 16px 20px;

  > .state {
    font-weight: 300;
    font-size: 12px;
  }
`;

export const PremiumPubTournamentNoData = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  background: #d9d9d9;
  width: calc(100% - 40px);
  height: 182px;
  font-weight: 700;
  font-size: 15px;
  text-align: center;
  color: #ffffff;
`;
